/**
 * Returns the betslip keyboard mappings for a certain currency code
 *
 * @param {string} key a number that defaults to zero when not provided.
 * @return {array} the keyboard mappings where each row is an item, with subitems which are buttons
 */

export default async key => (await import(/* webpackChunkName: "keyboard-mappings-[request]" */ `./keyboardMappings/${key}`)).default;
